import defaultAnalyticsConfig from "../../../src/common/analytics/defaultAnalyticsConfig";

export default class analyticsConfig extends defaultAnalyticsConfig {
  static erTag = defaultAnalyticsConfig.erTag;
}



// WEBPACK FOOTER //
// ./clients/mhu-ds/js/analyticsConfig.js